import { WageAndTravelReimbursementRequestStatus } from "../enums/watr-reimbursement-request-status";

export interface IWatrReimbursementRequestStatusChange {
    requestId: number,
    week: number,
    status: WageAndTravelReimbursementRequestStatus
}